export const APP_ID = {
  snail: 39,
  tideng: 33,
  servitor: 67,
  travel: 35,
  hjwq: 58,
  hjwq2: 58,
  sakura: 74,
  qscy: 47,
  mzzg: 50,
  snail_tw: 120,
  ares: 41,
};

export const PAGE_ID = {
  snail: 9,
  tideng: 3,
  servitor: 6,
  travel: 5,
  hjwq: 8,
  hjwq2: 8,
  sakura: 11,
  qscy: 17,
  mzzg: 17,
  snail_tw: 9,
  ares: 1,
};

export const SMS_GAME_ID = {
  snail: 39,
  tideng: 33,
  mzzg: 50,
  // 阿瑞斯 41
  hjwq: 69,
  sakura: 74,
  servitor: 67,
  qscy: 47,
  travel: 35,
}

export const GAME_AREA = {
  snail: [
    // 蜗牛
    { id: 26, name: "光子服" },
    { id: 39, name: "正式服" }
  ],
  tideng: [
    // 提灯
    { id: 42, name: "先锋服" },
    { id: 33, name: "正式服" }
  ],
  travel: [
    // 时光
    { id: 62, name: "光子服" },
    { id: 35, name: "正式服" }
  ],
  servitor: [
    // 使魔
    { id: 25, name: "光子服" },
    { id: 67, name: "正式服" }
  ],
  hjwq: [
    // 仙剑
    { id: 58, name: "光子服" },
    { id: 69, name: "正式服" }
  ],
  hjwq2: [
    // 仙剑
    { id: 58, name: "光子服" },
    { id: 69, name: "正式服" }
  ],
  sakura: [
    // 小樱
    { id: 61, name: "光子服" },
    { id: 74, name: "正式服" }
  ],
  qscy: [
    // 骑士冲呀
    { id: 47, name: "光子服" },
  ],
  mzzg: [
    // 迷途之光
    { id: 50, name: "正式服" },
  ],
  snail_tw: [
    // 蜗牛
    { id: 120, name: "正式服" }
  ],
  ares: [
    // 蜗牛
    { id: 41, name: "正式服" }
  ],
};

export const GAME_ARMS = {
  snail: { pid: "egrrccpv71@85f3ce24420385a" },
  tideng: { pid: "egrrccpv71@6dc0a96190ae53a" },
  travel: { pid: "egrrccpv71@232921d2c1e9c18" },
  servitor: { pid: "egrrccpv71@93f307f3692c05a" },
  hjwq: { pid: "egrrccpv71@a85ccdca6b0259c" },
  qingyu: { pid: "egrrccpv71@e21c72ea78504d0" },
  sakura: { pid: "egrrccpv71@b8ccae6ee3e9461" },
  qscy: { pid: "egrrccpv71@f96645307d637ee" },
  mzzg: { pid: "egrrccpv71@ef7af2c231f632b" },
  snail_tw: { pid: "egrrccpv71@d7f5ad167a51a5f" },
  ares: { pid: "egrrccpv71@aaec79e7982fdd2" },
};

/**
 * 游戏版权相关信息
 * - opUnit: 运营单位
 * - symbol: 文号
 * - publicationNo: 出版物号
 * - backup: 闽公安备份
 * - ICPNo:  ICP证
 * - MICPNo: 闽ICP备
 * - ageLimit: 年龄限制
 * - introLink: 公司简介链接
 * - userProtocolLink: 用户协议链接
 * - privacyLink: 隐私协议链接
 */
export const GAME_COPYRIGHT = {
  snail: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "国新出审【2019】2856号",
    publicationNo: "ISBN978-7-498-06856-9",
    backup: "闽公网安备35020302000994号",
    ICPNo: "闽B2-20150080",
    MICPNo: "闽ICP备15000623号-1",
    ageLimit: 12,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  tideng: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "闽网文[2018]2592-119",
    publicationNo: "ISBN978-7-498-07529-1",
    backup: "闽公网安备35020302000994号",
    ICPNo: "闽B2-20150080",
    MICPNo: "闽ICP备15000623号-1",
    ageLimit: 12,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  travel: {
    opUnit: "成都青瓷拾光网络科技有限公司",
    symbol: "国新出审[2020]843号",
    publicationNo: "978-7-498-07602-1",
    backup: "川公网安备51019002005713号",
    ICPNo: "川B2-20231346",
    MICPNo: "蜀ICP备2023017135号-1",
    ageLimit: 12,
    introLink: "https://www.qingcitimes.com/about_us.html",
    userProtocolLink: "https://law.qingcijoy.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcijoy.com/zh-cn/privacy_policy.html"
  },
  servitor: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "国新出审[2018]1238号",
    publicationNo: "978-7-498-05581-1",
    backup: "闽公网安备35020302000994号",
    ICPNo: "闽B2-20150080",
    MICPNo: "闽ICP备15000623号-1",
    ageLimit: 12,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  hjwq: {
    opUnit: "成都青瓷互动网络科技有限公司",
    symbol: "国新出审[2022]1739号",
    publicationNo: "978-7-498-09911-2",
    backup: "川公网安备 51019002004205号",
    ICPNo: "川B2-20211792",
    MICPNo: "蜀ICP备2021023869号-1",
    ageLimit: 16,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  hjwq2: {
    opUnit: "成都青瓷互动网络科技有限公司",
    symbol: "国新出审[2022]1739号",
    publicationNo: "978-7-498-09911-2",
    backup: "川公网安备 51019002004205号",
    ICPNo: "川B2-20211792",
    MICPNo: "蜀ICP备2021023869号-1",
    ageLimit: 16,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  sakura: {
    opUnit: "上海黑桃互动网络科技股份有限公司",
    symbol: "国新出审[2023]374号",
    publicationNo: "ISBN 978-7-498-12123-3",
    backup: "川公网安备51019002004205号",
    ICPNo: "川B2-20211792",
    MICPNo: "蜀ICP备2021023869号-1",
    ageLimit: 12,
    introLink: "https://www.qingcijoy.com/",
    userProtocolLink: "https://law.qingcijoy.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcijoy.com/zh-cn/privacy_policy.html"
  },
  qscy: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "国新出审[2023] 1204号",
    publicationNo: "978-7-498-12542-2",
    backup: "闽公网安备35020302000994号",
    ICPNo: "闽B2-20150080",
    MICPNo: "闽ICP备15000623号-1",
    // ageLimit: 12,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcigame.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcigame.com/zh-cn/privacy_policy.html"
  },
  mzzg: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "国新出审[2023] 2355号",
    publicationNo: "978-7-498-12987-1",
    backup: "川公网安备51019002004205号",
    ICPNo: "川B2-20211792",
    MICPNo: "蜀ICP备2021023869号-1",
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.qingcijoy.com/zh-cn/service_agreement.html",
    privacyLink: "https://law.qingcijoy.com/zh-cn/privacy_policy.html"
  },
  snail_tw: {
    opUnit: "厦门青瓷文化传播有限公司",
    symbol: "国新出审【2019】2856号",
    publicationNo: "ISBN978-7-498-06856-9",
    backup: "闽公网安备35020302000994号",
    ICPNo: "闽B2-20150080",
    MICPNo: "闽ICP备15000623号-1",
    ageLimit: 12,
    introLink: "http://www.qingcigame.com/about_us.html",
    userProtocolLink: "https://law.snell.com.tw/zh-tw/service_agreement.html",
    privacyLink: "https://law.snell.com.tw/zh-tw/privacy_policy.html"
  },
};



// WEBPACK FOOTER //
// ./src/config/constant.js